uniform vec3 uBaseColor;
uniform vec3 uFresnelColor;
uniform float uFresnelPower;
uniform float opacity;
varying vec3 vPositionW;
varying vec3 vNormalW;

void main() {
  vec3 viewDirectionW = normalize(cameraPosition - vPositionW);
  float fresnelTerm = dot(viewDirectionW, vNormalW);
  fresnelTerm = clamp(1.0 - fresnelTerm, 0., 1.);
  fresnelTerm = pow(fresnelTerm, uFresnelPower);

  vec3 color1 = mix(uBaseColor, uFresnelColor, fresnelTerm);
  gl_FragColor = vec4(color1, opacity);
  // gl_FragColor = vec4(viewDirectionW, 1.);

}